module.exports = __webpack_public_path__ + "static/media/G1-10-Alana-Dimitris-cod30.ae182f2d.png";